const BLOCKED_EMAILS = new Set(['kyle.wilson@litta.co'])
const ALLOWED_EMAIL_DOMAINS = ['litta.co', 'litta.co.uk']

function normalizeEmail(email: string | null | undefined): string {
    return (email ?? '').trim().toLowerCase()
}

export function isAllowedCompanyEmail(
    email: string | null | undefined,
): boolean {
    const normalizedEmail = normalizeEmail(email)

    if (!normalizedEmail || BLOCKED_EMAILS.has(normalizedEmail)) {
        return false
    }

    return ALLOWED_EMAIL_DOMAINS.some(domain =>
        normalizedEmail.endsWith(`@${domain}`),
    )
}

const LOCAL_PREVIEW_HOSTNAMES = new Set(['localhost', '127.0.0.1'])
const PREVIEW_LINK_WEB_APP_PATTERN = /--.+\.web\.app$/i

// Popup sign-in on hosts whose origin differs from the Firebase authDomain
// (localhost, *.web.app previews); a cross-domain redirect there gets blocked by
// third-party-cookie rules. Live (same-domain) uses redirect.
export function shouldUsePopupSignIn(hostname: string): boolean {
    return (
        LOCAL_PREVIEW_HOSTNAMES.has(hostname) ||
        PREVIEW_LINK_WEB_APP_PATTERN.test(hostname)
    )
}

// Popup hosts use the staging project's own Hosting domain:
// staging.beehive.litta.co is hosted in book-litta-co, whose auth handler
// rejects the staging API key. Redirect hosts must keep their own domain.
export function getStagingAuthDomain(hostname: string): string {
    return shouldUsePopupSignIn(hostname)
        ? 'staging-9c37f.firebaseapp.com'
        : 'staging.beehive.litta.co'
}

// User-facing message for a Firebase sign-in failure, or null when there is
// nothing to show (e.g. the user dismissed the popup).
export function describeSignInError(err: unknown): string | null {
    const code = (err as { code?: string })?.code ?? ''
    if (
        code === 'auth/popup-closed-by-user' ||
        code === 'auth/cancelled-popup-request'
    ) {
        return null
    }
    if (code === 'auth/popup-blocked') {
        return 'Your browser blocked the sign-in popup. Allow popups for this site, then try again.'
    }
    console.error('Sign-in error', err)
    return 'Sign-in failed. Please try again.'
}
